import { Location, ApiResponse, LocationFormData } from '@court-sync/shared';
import { apiGet, apiPost, apiPut, apiDelete, publicApiGet } from './apiClient';

export const locationService = {
  async getLocations(academyId: string, includeInactive = false): Promise<ApiResponse<Location[]>> {
    return apiGet<Location[]>('/locations', {
      params: { academyId, includeInactive: includeInactive ? 'true' : undefined },
    });
  },

  async createLocation(
    payload: LocationFormData & { academyId: string }
  ): Promise<ApiResponse<Location | null>> {
    return apiPost<Location | null>('/locations', payload);
  },

  async updateLocation(
    id: string,
    payload: LocationFormData & { academyId: string }
  ): Promise<ApiResponse<Location | null>> {
    return apiPut<Location | null>(`/locations/${id}`, payload);
  },

  async deleteLocation(id: string, academyId: string): Promise<ApiResponse> {
    return apiDelete(`/locations/${id}`, { params: { academyId } });
  },
};

export async function getPublicLocations(academyId: string): Promise<ApiResponse<Location[]>> {
  return publicApiGet<Location[]>(`/public/locations/academy/${academyId}`);
}
